// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__IrRCd","a":"Footer_a__1jJEk"};